import _ from "lodash";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SelectInput from "../../framework/SelectInput";
import { searchManufacturer } from "../../services/manufacturer-services";

const ManufacturerCellSelectEditor = forwardRef((props, ref) => {
  const { value } = props;

  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const inputRef = useRef(null);

  // Focus input when editor mounts
  useEffect(() => {
    const id = setTimeout(
      () => inputRef.current?.focus?.({ preventScroll: true }),
      0
    );
    return () => clearTimeout(id);
  }, []);

  useEffect(() => {
    if (value) setSelected(value);
  }, [value]);

  const fetchManufacturers = useCallback(async (term) => {
    const q = (term || "").trim();
    const response = await searchManufacturer(`manufacturerName=${q}`);
    const rows = Array.isArray(response?.result?.rows)
      ? response.result.rows
      : Array.isArray(response?.rows)
      ? response.rows
      : [];
    const opts = rows.map((m) => ({
      id: m.manufacturerId,
      label: m.manufacturerName,
    }));
    setOptions(opts);
  }, []);

  // Debounce input changes
  const debouncedFetch = useMemo(
    () => _.debounce(fetchManufacturers, 250),
    [fetchManufacturers]
  );
  useEffect(() => {
    return () => debouncedFetch.cancel();
  }, [debouncedFetch]);

  useImperativeHandle(ref, () => ({
    getValue: () => selected,
    isCancelAfterEnd: () => false,
  }));

  return (
    <div className="ag-grid-select-input">
      <SelectInput
        ref={inputRef}
        value={selected}
        options={options}
        freeSolo
        openOnFocus={true}
        getOptionLabel={(option) => option?.label || option}
        isOptionEqualToValue={(option, value) => {
          const optionId = option?.id ?? option?.manufacturerId;
          const valueId = value?.id ?? value?.manufacturerId;
          if (optionId && valueId) return optionId === valueId;
          return option?.label === (value?.label || value);
        }}
        onChange={(e, newValue) => setSelected(newValue)}
        onFocus={() => {
          // Trigger search immediately on focus
          fetchManufacturers("");
        }}
        onInputChange={(e, val, reason) => {
          if (reason === "reset") return;
          debouncedFetch(typeof val === "string" ? val : e?.target?.value || "");
        }}
        InputProps={{ style: { background: "white" } }}
      />
    </div>
  );
});

export default ManufacturerCellSelectEditor;


